import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import {
  getStallTypes,
  saveStallType,
  updateStallType,
  deleteStallType,
} from "../Apis/StallTypeAPIs";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";

const StallTypeLayer = () => {
  const [stallTypes, setStallTypes] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);

  // Modal State
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState("");

  const fetchStallTypes = async () => {
    setLoading(true);
    const res = await getStallTypes();
    if (res.status) {
      setStallTypes(res.response?.data || res.response || []);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchStallTypes();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputValue.trim()) {
      setError("Stall Type Name is Required");
      return;
    }

    if (editId) {
      const res = await updateStallType(editId, { stallTypeName: inputValue });
      if (res.status) {
        // toast.success("Stall Type Updated Successfully");
        setInputValue("");
        setEditId(null);
        fetchStallTypes();
      }
    } else {
      const res = await saveStallType({ stallTypeName: inputValue });
      if (res.status) {
        toast.success("Stall Type Added Successfully");
        setInputValue("");
        setError("");
        fetchStallTypes();
      }
    }
  };

  const handleEdit = (item) => {
    setEditId(item._id || item.id);
    setInputValue(item.stallTypeName || item.name);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    setIsUpdating(true);
    const res = await deleteStallType(itemToDelete._id || itemToDelete.id);
    if (res.status) {
      toast.success("Stall Type Deleted Successfully");
      fetchStallTypes();
      setShowDeleteModal(false);
      setItemToDelete(null);
    }
    setIsUpdating(false);
  };

  return (
    <div className="card h-100 p-0 radius-12 overflow-hidden">
      <div
        className="card-header border-bottom py-16 px-24 d-flex align-items-center justify-content-between"
        style={{
          background:
            "linear-gradient(135deg, #000000 0%, #bb0007 50%, #ed1c24 100%)",
        }}
      >
        <h6 className="text-white mb-0">Stall Type </h6>
      </div>
      <div className="card-body p-24">
        <form onSubmit={handleSubmit} className="row g-3 align-items-start mb-40">
          <div className="col-md-8">
            <label className="form-label fw-bold">
              Stall Type Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control radius-8 ${error ? "is-invalid" : ""}`}
              placeholder="e.g. Normal, Premium, Corner"
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
                if (error) setError("");
              }}
            />
            {error && <div className="invalid-feedback">{error}</div>}
          </div>
          <div className="col-md-4">
            <button
              type="submit"
              className="btn radius-8 w-100 py-11 fw-bold mt-32 d-flex align-items-center justify-content-center gap-2"
              style={{ backgroundColor: "#f7e7da", color: "black", fontWeight: "600", border: "none" }}
            >
              {!editId && <Icon icon="ic:baseline-plus" className="text-xl" />}
              {editId ? "Update Stall Type" : "Add Stall Type"}
            </button>
          </div>
        </form>

        <div className="table-responsive scroll-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr style={{ backgroundColor: "#f7e7da" }}>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>
                  S.No
                </th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>
                  Stall Type Name
                </th>
                <th
                  scope="col"
                  className="text-center"
                  style={{ color: "black", fontWeight: "bold" }}
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="3" className="text-center py-24">
                    Loading...
                  </td>
                </tr>
              ) : stallTypes.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center py-24">
                    No stall types found
                  </td>
                </tr>
              ) : (
                stallTypes.map((item, index) => (
                  <tr key={item._id || item.id}>
                    <td>{index + 1}</td>
                    <td >
                      {item.stallTypeName || item.name}
                    </td>
                    <td className="text-center">
                      <div className="d-flex align-items-center justify-content-center gap-2">
                        <button
                          onClick={() => handleEdit(item)}
                          className="btn-edit-custom fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          title="Edit"
                        >
                          <Icon icon="lucide:edit" className="menu-icon" />
                        </button>
                        <button
                          onClick={() => handleDeleteClick(item)}
                          title="Delete"
                          className="bg-danger-focus text-danger-600 bg-hover-danger-200 w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle border-0"
                        >
                          <Icon icon="lucide:trash-2" className="text-xl" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Body className="text-center p-5">
          <div className="d-flex justify-content-center mb-3">
            <div className="bg-danger-focus rounded-circle d-flex justify-content-center align-items-center w-64-px h-64-px">
              <Icon
                icon="solar:trash-bin-trash-bold"
                className="text-danger-600 text-xxl"
              />
            </div>
          </div>
          <h5 className="mb-2">Are you sure?</h5>
          <p className="text-secondary-light mb-4">
            Do you want to delete stall type "{itemToDelete?.stallTypeName || itemToDelete?.name}"?
          </p>
          <div className="d-flex justify-content-center gap-3 mt-4">
            <Button
              variant="outline-secondary"
              className="px-32 radius-8"
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="px-32 radius-8 border-0"
              onClick={confirmDelete}
              disabled={isUpdating}
              style={{
                backgroundColor: "#ed1c24",
                color: "white",
              }}
            >
              {isUpdating ? "Deleting..." : "Confirm"}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default StallTypeLayer;
